import { Moment } from "moment";
import * as commRegexp from "./CommonRegExp";
import { generateUTCDate } from "./Date";

// By default, the regexes will contain a capturing parentheses and the index of the captured group is then 1
/**
 * Get the string at an index from a matched array.
 * @param obj RegExpMatchArray with all the matched elements
 * @param i The index to check and then return (default = 1)
 * @default {i = 1}
 * @returns Matched string
 */
export const getMatch = (obj: RegExpMatchArray | null, i = 1): string => {
  return obj !== null && obj[i] !== undefined ? obj[i] : "";
};

// Replace multiple spaces with a single space
export const trimmer = (input: string): string => {
  return input.replace(commRegexp.whitespaceRegex, " ");
};

// A function for getting a string from a regex
/**
 * Get a string from a text with a regex
 * @param input The whole string
 * @param regexp The regex to extract the string
 * @returns Matched string or null if no match
 */
export const getStringFromRegExp = (
  input: string,
  regexp: RegExp
): string | null => {
  const res: string = getMatch(input.match(regexp));
  return res !== "" ? res : null;
};

// Same as above, returns a parsed number
/**
 * Get a number from a text with a regex
 * @param input The whole string
 * @param regexp The regex to extract the string
 * @returns Matched number returned as parsed int or null if no match
 */
export const getIntFromRegExp = (
  input: string,
  regexp: RegExp
): number | null => {
  const res: string = getMatch(input.match(regexp));
  return res !== "" ? parseInt(res) : null;
};

// Includes day, hour and minute which is found on multiple occasions in aftn messages
/**
 * A parser to extract an IDateTime object from a string with a provided regex.
 * @param input The whole input string
 * @param regex The regex used to match date/time element
 * @returns Momentor undefined if no match
 */
export const dateParser = (
  input: string,
  regex: RegExp
): Moment | undefined => {
  const date: string = getMatch(input.match(regex));
  if (date) {
    const hour = parseInt(date.substring(2, 4));
    const day = parseInt(date.substring(0, 2)) + (hour === 24 ? 1 : 0);
    const minute = parseInt(date.substring(4, 6));
    return generateUTCDate(minute, hour, day);
  } else {
    return undefined;
  }
};

/**
 * A parser to extract an ITime from a string with a provided regex.
 * @param input The whole input string
 * @param regex The regex used to match hour/minute
 * @returns Moment or undefined of no match
 */
export const timeParser = (
  input: string,
  regex: RegExp
): Moment | undefined => {
  const time: string = getMatch(input.match(regex));
  if (time) {
    const hour = parseInt(time.substring(0, 2));
    const minute = parseInt(time.substring(2, 6));
    return generateUTCDate(minute, hour);
  } else {
    return undefined;
  }
};
